// extracted by mini-css-extract-plugin
export default {"stickyBtnWrap":"Style_stickyBtnWrap__ourqO","upperWrap":"Style_upperWrap__vebYe","upperNum":"Style_upperNum__vVCNk","btnWrap":"Style_btnWrap__dAgQ-","edit":"Style_edit__+jcqM"};